/**
 * Constrain a post-login redirect target to an in-app path.
 *
 * Accepts only paths that start with a single "/" — rejecting absolute URLs
 * ("https://evil.com"), protocol-relative ("//evil.com"), and backslash
 * variants ("/\evil.com", which browsers normalize to "//"). Today react-
 * router's navigate(..., { replace: true }) happens to fail safely on such
 * values, but that safety is an accident of router internals — this makes
 * the same-origin guarantee explicit.
 */
export function safeInternalPath(path: string | null | undefined, fallback = '/home'): string {
  if (!path) return fallback;
  return /^\/(?![/\\])/.test(path) ? path : fallback;
}
